export default "__VITE_ASSET__d5ac3963__"